'use client';

import { useTranslation } from 'react-i18next';

import { RadioGroup } from '@sola/ark-core/molecules/radio-group/radio-group.js';

import { useDonate } from '../donate-context';
import { DonateFrequency } from '../donate.types';
import { useDonateActions } from '../hooks/use-donate-actions';

export const DonateFrequencySelector: React.FC<{ className?: string }> = ({
  className,
}) => {
  const { t } = useTranslation();
  const { state, config } = useDonate();
  const { handleFrequencyChange } = useDonateActions();

  const frequencyItems = config.enabledFrequencies.map((frequency) => ({
    value: frequency.toString(),
    text: `${t('skippy.donation.frequency', { context: frequency })}`,
    disabled: false,
  }));

  if (!config.defaultFrequency || frequencyItems.length <= 1) {
    return null;
  }

  return (
    <div
      className={`DonateFrequencySelector w-full flex justify-center items-center ${className}`}
    >
      <RadioGroup
        key={`${state.donateFrequency}-frequency`}
        name="donateFrequency"
        items={frequencyItems}
        orientation="horizontal"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleFrequencyChange(e.target.value as DonateFrequency)
        }
        value={state.donateFrequency}
      />
    </div>
  );
};
